import React from 'react';
import PropTypes from 'prop-types';

import { parseSum } from 'utils/helpers';
import { TableCell, TableRow, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    totalCell: {
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing(),
    },
    buttonCell: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing(),
    },
}));

const TotalRow = ({ totals, labels, firstColspan, maxColspan, buttonComponent }) => {
    const classes = useStyles();
    const secondColspan = buttonComponent ? 1 : maxColspan - firstColspan;
    const thirdColspan = buttonComponent ? maxColspan - firstColspan - 1 : 0;

    return (
        <TableRow>
            <TableCell colSpan={firstColspan} align="right" className={classes.totalCell}>
                {labels
                    .filter((_, i) => !!totals[i])
                    .map(label => (
                        <Typography fontWeight={600} key={label}>
                            {label}
                        </Typography>
                    ))}
            </TableCell>
            <TableCell colSpan={secondColspan} className={classes.totalCell}>
                {totals
                    .filter(t => !!t)
                    .map((total, i) => (
                        <p key={i}>{parseSum(total)}</p>
                    ))}
            </TableCell>
            <TableCell colSpan={thirdColspan} className={classes.buttonCell}>
                {buttonComponent}
            </TableCell>
        </TableRow>
    );
};

TotalRow.propTypes = {
    firstColspan: PropTypes.number,
    maxColspan: PropTypes.number,
    buttonComponent: PropTypes.node,
    labels: PropTypes.array,
    totals: PropTypes.array,
};

export default TotalRow;
